// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__15TTL","title":"ClientInsurance_title__1ngEy","itemText":"ClientInsurance_itemText__2XRi1"};